import API from './API'
import {Deserialize} from "cerialize";
import Package from "@/ts/interfaces/Package";

export default class AppPackages extends API {

    static getAppPackages(): Promise<Package[]> {
        return super.baseRequest("GET", `admin/app_packets/`, null).then(res => {
            return Deserialize(res, Package)
        });
    }

    static createPackage(packet_name: string, template_packet_id: number, order_index: number) {
        return API.baseRequest("POST", `admin/app_packets/`, {packet_name, template_packet_id, order_index})
    }

    static getSinglePackage(packet_id: number): Promise<Package> {
        return super.baseRequest("GET", `admin/app_packets/${packet_id}`, null).then(res => {
            return Deserialize(res, Package)
        });
    }

    static updatePackage(packet_id: number, packet_name: string, order_index: number) {
        return API.baseRequest("PUT", `admin/app_packets/${packet_id}`, {packet_name, order_index})
    }

    static deletePackage(packet_id: number) {
        return API.baseRequest("DELETE", `admin/app_packets/${packet_id}`, null)
    }
}
